module.exports = __webpack_public_path__ + "img/blue-cross-icon.faba92c8.svg";